import { PlayerOrNoneGameStateWithTable } from '../../jscaip/state/PlayerOrNoneGameStateWithTable';
export class QuixoState extends PlayerOrNoneGameStateWithTable {
    applyLegalMove(move) {
        const newBoard = this.getCopiedBoard();
        const newTurn = this.turn + 1;
        let currentCoordToFill = move.coord;
        let nextCoordToSlide = move.coord.getNext(move.direction);
        while (this.isOnBoard(nextCoordToSlide)) {
            newBoard[currentCoordToFill.y][currentCoordToFill.x] = newBoard[nextCoordToSlide.y][nextCoordToSlide.x];
            currentCoordToFill = currentCoordToFill.getNext(move.direction);
            nextCoordToSlide = nextCoordToSlide.getNext(move.direction);
        }
        newBoard[currentCoordToFill.y][currentCoordToFill.x] = this.getCurrentPlayer();
        return new QuixoState(newBoard, newTurn);
    }
}
